<template>
  <b-modal
    id="unity-material"
    ref="fromUnityModal"
    centered
    hide-footer
    v-model="showModal"
    size="lg"
    title="Agregar desde Unidad"
    no-close-on-backdrop
    no-close-on-esc
    @close="onModalClose()"
  >
  <vx-card
    class="fill"
    title-color="primary"
  >
    <div class="row">
      <div class="col-6">
        <label>Buscar por coincidencias Nombre Material</label>
        <b-input-group>
          <b-input-group-prepend is-text>
            <b-icon icon="search"></b-icon>
          </b-input-group-prepend>
          <b-form-input
            v-model="textSearch"
          />
        </b-input-group>
      </div>
    </div>
    <div class="row mt-1">
      <div class="col-5">
        <label>Categoría</label> <select
        type="select"
        class="form-control"
        v-model="categoryMaterial"
      >
        <option
          selected
          value=""
        ></option>
        <option
          v-for="option in listCategorys"
          v-bind:value="{ value: option.categoryId, text: option.categoryName}"
          v-bind:key="option.categoryId"
        >
          {{ option.categoryName }}
        </option>
      </select>
      </div>
      <div class="col-5">
        <label>Marca:</label> <select
        type="select"
        class="form-control"
        v-model="brandMaterial"
      >
        <option
          selected
          value=""
        ></option>
        <option
          v-for="option in listBrands"
          v-bind:value="{ value: option.brandId, text: option.brandName}"
          v-bind:key="option.brandId"
        >
          {{ option.brandName }}
        </option>
      </select>
      </div>
      <div class="col-2 align-self-end">
        <vs-chip
          style="cursor:pointer;"
          @click.native="searchListMaterial()"
        >
          <vs-avatar
            icon="search"
            color="primary"
          />
          <strong>Buscar</strong>
        </vs-chip>
      </div>
    </div>
  </vx-card>
  <div
    class="row mt-3"
  >
    <div class="col-12">
      <b-table
        class="h-100"
        ref="selectableTable"
        :fields="fieldMaterial"
        :items="listMaterials"
        :tbody-tr-class="rowClass"
        hover
        :select-mode="onTableSelected"
        selectable
        sticky-header
        @row-selected="onRowSelected"
      >
        <template #cell(selected)="{ rowSelected }">
          <template v-if="rowSelected">
            <span aria-hidden="true">&check;</span>
          </template>
          <template v-else>
            <span aria-hidden="true">&nbsp;</span>
          </template>
        </template>
        <template #cell(categoryMaterial)="row">
          {{ row.item.categoryMaterial.descripcion }}
        </template>
        <template #cell(brandMaterial)="row">
          {{ row.item.brandMaterial.descripcion }}
        </template>
        <template #cell(priceMaterial)="row">
          {{ parseInt(row.item.priceMaterial) | toCurrency }}
        </template>
      </b-table>
    </div>
  </div>
  <div class="row">
    <template v-if="enableActions() && this.whoCall === '' ">
      <span
        class="col-auto"
        aria-hidden="true"
      >{{ selected[0].nameMaterial }}</span>
      <div class="col-3">
        <b-form-input
          type="number"
          placeholder="Ingresa cantidad"
          size="sm"
          v-model="qtyMaterial"
        ></b-form-input>
      </div>
    </template>
  </div>
  <div class="d-flex align-items-end">
    <MaterialPagination
      v-model="actualPage"
      v-on:change="onPageChange"
    />
  </div>
  <hr>
  <div class="row">
    <div class="col-12">
      <b-button
        class="btn pull-right ml-3"
        size="sm"
        @click="onModalClose"
      >
        Cancelar
      </b-button>
      <b-button
        v-if="whoCall === ''"
        :disabled="!enableActions()"
        class="btn btn-primary pull-right ml-3"
        size="sm"
        @click="addMaterialEntity"
      >
        Guardar
      </b-button>
      <b-button
        v-if="whoCall === 'catalog'"
        :disabled="!enableActions()"
        class="btn btn-primary pull-right ml-3"
        size="sm"
        @click="addMaterial"
      >
        Guardar
      </b-button>
    </div>
  </div>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import MaterialPagination from '@/febos/global/materialsRequests/components/MaterialPagination';
import MaterialProcessState from '@/febos/global/materialsRequests/mixins/MaterialProcessState';

export default {
  name: 'PopUpAddFromUnity',
  components: {
    MaterialPagination
  },
  props: {
    whoCall: {
      type: String,
      default: ''
    },
    materialObject: null
  },
  data() {
    return {
      materialState: MaterialProcessState,
      selected: [],
      selectClass: '',
      textSearch: '',
      qtyMaterial: 1,
      categoryMaterial: null,
      brandMaterial: null,
      fieldMaterial: [
        { key: 'selected', label: '' },
        { key: 'skuMaterial', label: 'SKU' },
        { key: 'nameMaterial', label: 'Nombre Material' },
        { key: 'priceMaterial', label: 'Precio Unitario' }
      ],
      arrayFilter: [],
      actualPage: 1,
      paginate: 5
    };
  },
  computed: {
    ...mapGetters('Modals', [
      'modalName'
    ]),
    ...mapGetters('Materials', [
      'pagination',
      'listMaterials',
      'listCategorys',
      'listBrands',
      'loading'
    ]),
    showModal: {
      get() {
        return this.modalName === 'PopUpAddFromUnity';
      },
      set() {
        this.closeModal();
      }
    },
    onTableSelected() {
      if (this.whoCall === 'catalog') {
        return 'multi';
      }
      return 'single';
    }
  },
  methods: {
    ...mapActions('Modals', [
      'closeModal'
    ]),
    ...mapActions('Materials', [
      'loadListMaterial',
      'loadListCategory',
      'loadListBrand'
    ]),
    onPageChange() {
      this.searchListMaterial();
    },
    onRowSelected(items) {
      this.selected = items;
    },
    rowClass(item, type) {
      if (!item || type !== 'row') return;
      // eslint-disable-next-line consistent-return
      if (item.seleccionado === 'awesome') return 'table-success';
    },
    // eslint-disable-next-line consistent-return
    enableActions() {
      if (this.selected.length === 0) return false;
      if (this.selected.length > 0) return true;
    },
    loadFormMaterial() {
      this.searchListMaterial();
      this.loadListCategory();
      this.loadListBrand();
    },
    searchListMaterial() {
      const filterContent = this.setArrayFilter();
      const query = {
        params: {
          tipo: 'productos',
          campos: '*',
          pagina: this.actualPage,
          orden: '-SKU',
          itemsPorPagina: this.paginate,
          filtros: filterContent !== '' ? filterContent : ''
        }
      };
      this.loadListMaterial(query);
    },
    setArrayFilter() {
      this.arrayFilter = [];
      this.arrayFilter.push({
        campo: 'estado',
        valor: this.materialState.ACTIVE
      });
      if (this.textSearch) {
        this.arrayFilter.push({
          campo: 'nombre',
          valor: this.textSearch.toLowerCase()
        });
      }
      if (this.categoryMaterial !== null && this.categoryMaterial !== '') {
        this.arrayFilter.push({
          campo: 'categorias.opcionId',
          valor: this.categoryMaterial.value
        });
      }
      if (this.brandMaterial !== null && this.brandMaterial !== '') {
        this.arrayFilter.push({
          campo: 'marca.opcionId',
          valor: this.brandMaterial.value
        });
      }
      const filter = [];
      this.arrayFilter.forEach((item) => {
        if (item.campo === 'nombre') filter.push(`${ item.campo }$${ item.valor }`);
        else filter.push(`${ item.campo }:${ item.valor }`);
      });
      return filter.join('|');
    },
    onModalClose() {
      this.closeModal();
    },
    addMaterialEntity() {
      const material = this.selected.map((data) => ({
        idCatalog: 0,
        nombreCatalogo: '',
        materiales: {
          categoria: [{
            opcionId: data.categoryMaterial.opcionId,
            descripcion: data.categoryMaterial.descripcion
          }],
          marca: {
            opcionId: data.brandMaterial.opcionId,
            descripcion: data.brandMaterial.descripcion
          },
          nombre: data.nameMaterial,
          precio: data.priceMaterial,
          SKU: data.skuMaterial,
          cantidad: Number.parseInt(this.qtyMaterial, 10),
          cantidadSolicitar: Number.parseInt(this.qtyMaterial, 10),
          total: Number.parseInt(this.qtyMaterial, 10) * data.priceMaterial,
          totalSolicitar: Number.parseInt(this.qtyMaterial, 10) * data.priceMaterial
        }
      }));
      this.$emit('reload', material);
      this.qtyMaterial = 1;
      this.closeModal();
    },
    addMaterial() {
      const Id = this.materialObject.catalogId;
      const material = this.selected.map((data) => ({
        catalogId: Id,
        categoryMaterial: [{
          opcionId: data.categoryMaterial.opcionId,
          descripcion: data.categoryMaterial.descripcion
        }],
        brandMaterial: {
          opcionId: data.brandMaterial.opcionId,
          descripcion: data.brandMaterial.descripcion
        },
        nameMaterial: data.nameMaterial,
        priceMaterial: data.priceMaterial,
        skuMaterial: data.skuMaterial,
        quantityMaterial: Number.parseInt(this.qtyMaterial, 10),
        imageMaterial: '',
        currencyMaterial: 'CLP'
      }));
      this.$emit('reload', material);
      this.qtyMaterial = 1;
      this.closeModal();
    }
  }
};
</script>
